import React from 'react'
import { FontFamily, TextAlign } from '@gousto-internal/citrus-react'
import { dietaryClaimAcronyms, getDietaryClaims } from '../../utils/getRecipeDietaryClaims'
import { DietaryIcons } from './DietaryIcons.styled'
import { Recipe } from '@library/menu-service'

export const DietaryLabels = ({ recipe }: { recipe: Recipe }) => {
  const dietaryClaims = getDietaryClaims(recipe)

  return (
    <>
      {dietaryClaims.map((claim) => (
        <DietaryIcons
          key={claim}
          fontFamily={FontFamily.Bold}
          size={2}
          textAlign={TextAlign.Center}
        >
          {dietaryClaimAcronyms[claim]}
        </DietaryIcons>
      ))}
    </>
  )
}
